import { createFileRoute } from '@tanstack/react-router';

import { TargetingBuilderEditorPage } from '../features/targeting/builder/components/TargetingBuilderEditorPage';

export const Route = createFileRoute('/targeting/new')({
  component: NewTargetingPage,
});

function NewTargetingPage() {
  return <TargetingBuilderEditorPage />;
}
